import makeService from './api';

export default makeService('quality_foci');
